export default __webpack_public_path__ + "static/media/grandmaAndLady3.61f1f703.jpg";